<template>

   
    <v-card color="light_gray">
          <v-card-text class="pa-4 def-font">
             <v-icon left small color="warning">mdi-cogs</v-icon> Activities
              <v-divider class="mb-4"/>
                <v-list two-line>
                <v-list-item  v-for="(item, index) in logs" :key="index + '-l'" style="border-bottom: 1px solid #ddd;">
                <v-list-item-content>
                    <v-list-item-subtitle><span class="text--primary">{{ item.user }} - </span> {{ item.message }}</v-list-item-subtitle>
                     <v-list-item-subtitle><span class="text-info font-italic def-font">{{ item.timestamp }} </span></v-list-item-subtitle>
                </v-list-item-content>
                </v-list-item>
              
              </v-list>  
                <div v-if="sales.status != 'Completed'">
                    <v-textarea rows="2" v-model="message" label="Write your comments"  maxlength="160" outlined hide-details=""/>
                   <p class="text-right pa-2"> <v-btn small @click="Post()">Post</v-btn></p>
                   
                </div>
          </v-card-text>
    </v-card>

</template>

<script>
import { API_MIXINS } from '@/mixins/api_mixins.js'
export default {
    mixins: [API_MIXINS],
  props: {
      show: {
          type: Boolean,
          default: false
      },
      sales: {
          type: Object,
          default: ()=>{}
      },

  },
  data () {
      return {
        valid: true,
        logs: [],
        message:""
      }
    },
  watch: {
        show(v){
            if(v) {
                    this.logs = this.sales.service_logs
            }
            
        }
  },
  computed:{
   
  },
  methods: {
   emitToParent (action) {
      this.$emit('DialogEvent', action)
    },
    Post(){
            if(this.message.length < 5) {
                 this.VA_ALERT("warning", "Your comment is too short", 'close', 500, 2000)
                    return
            }
            this.logs.push( {
                "user": this.$session.get('fullname'),
                "message": this.Strip(this.message),
                "timestamp": this.$moment().format("YYYY-MM-DD hh:mm A")
            })
           let params = {
            table: "sales", 
            type:"update",
            query:`update sales set  service_logs='${JSON.stringify(this.logs)}'::jsonb where id=${this.sales.id}`
        }
   
        this.$http.post("new_data", params).then(response => {
          console.log(response)
          this.VA_ALERT(response.data.status?'success':'error', response.data.message, response.data.status?'check':'close', 500, 2000)
        this.message = ""
        }).catch(e => {
          console.log(e.data)
        })
    }
  }
}
</script>
